import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import GoodsItem from '../GoodsItem';
import { Flex } from 'antd-mobile';
import styles from './index.modules.less';

export default forwardRef(({ name, list, sourceTag }, ref) => {
  const Tab = ({ children, title }) => {
    return (
      <Flex
        style={{ flexDirection: 'row' }}
        className={styles.container}
        wrap="wrap"
        align="center"
        title={title}>
        {children}
      </Flex>
    );
  };
  return (
    <React.Fragment>
      <Tab title={name}>
        {(list || []).map((item, index) => {
          return <GoodsItem key={index} item={item} index={index} sourceTag={sourceTag} />;
        })}
      </Tab>
    </React.Fragment>
  );
});



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/Tabs/Components/PageList/index.jsx